<template>
  <div class="flex w-full items-center gap-2" :class="{ '-my-1 justify-end': inTableRow }">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    inTableRow: Boolean,
  },
};
</script>
